import styled from '@emotion/styled';
import { themeColors } from 'theme/theme.config';

export const SInfoField = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SInfoFieldLabel = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: ${themeColors.character.title85};
  margin-bottom: 16px;
`;

export const SInfoFieldValue = styled.div`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${themeColors.character.title85};
  margin-bottom: 16px;
`;

export const SFormAmountWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  
  .custom-ant-form-item {
    flex: 1;
  }
`;

export const SBottomButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  gap: 20px;
  
  button {
    flex: 1;
  }
`;
